export const blockIconsNotificationSystemUpdate = (
	<span className='material-symbols-outlined'>system_update</span>
);
